export * from './details/details.controller';
export * from './details/IKubernetesLoadBalancer';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/kubernetes/src/v2/loadBalancer/index.ts